module.exports = __webpack_public_path__ + "img/americanfootball.7186a92f.svg";